let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7AD96")).then(() => parcelRequire('4UjsG'));